import {AccountMultipleIcon, LockIcon, TildeIcon} from '@time-webkit/all/icons';
import {ArchiveIcon} from '@time-webkit/all/icons/archive';
import {ChannelType} from '@time-webkit/all/types/general';

export const getChannelIcon = (type: ChannelType, archived = false) => {
    if (archived) {
        return ArchiveIcon;
    }

    switch (type) {
    case ChannelType.PUBLIC:
        return TildeIcon;
    case ChannelType.PRIVATE:
        return LockIcon;
    case ChannelType.GM:
        return AccountMultipleIcon;
    default:
        return TildeIcon;
    }
};
